const compareVersions = require("compare-versions");
const comparatorRegEx = /^([><=]+)?([0-9.]+)$/g;

function isVersion(version, comparison) {
	let args = comparatorRegEx.exec(comparison);

	if (args) {
		let comparator = args[1] || "=";
		let comparison = compareVersions(version, args[2]);

		switch (comparison) {
			case -1:
				return comparator.indexOf("<") !== -1;

			case 0:
				return comparator.indexOf("=") !== -1;

			case 1:
				return comparator.indexOf(">") !== -1;
		}
	}

	return false;
}

module.exports = {
	isVersion
};


// WEBPACK FOOTER //
// ./resources/js/helpers/version.js